import {inject, Injectable, signal, Type} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';

type DrawerSize = 'auto' | 'fill-height';

interface DrawerState {
  component: Type<unknown>;
  inputs: Record<string, unknown>;
  header: {
    content: string;
    style: 'centered' | 'left';
  };
  styleClass?: string;
  size: DrawerSize;
}

interface DrawerOpenOptions {
  header: {
    content: string;
    style: 'centered' | 'left';
  };
  inputs?: Record<string, unknown>;
  styleClass?: string;
  size?: DrawerSize;
}

@Injectable({providedIn: 'root'})
export class DrawerService {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly _visible = signal(false);
  private readonly _state = signal<DrawerState | null>(null);

  readonly visible = this._visible.asReadonly();
  readonly state = this._state.asReadonly();

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      const drawerParam = this.route.snapshot.queryParamMap.get('drawer');
      if (!drawerParam || drawerParam === 'false') {
        this.close();
      }
    });
  }

  open(component: Type<unknown>, options: DrawerOpenOptions): void {
    this._state.set({
      component,
      inputs: {...(options.inputs ?? {})},
      header: options.header,
      styleClass: options.styleClass ?? '',
      size: options.size ?? 'auto'
    });
    this._visible.set(true);
  }

  close(): void {
    this._visible.set(false);
    queueMicrotask(() => this._state.set(null));
  }
}
